import { Directive, Input, OnInit } from '@angular/core';

import { NotificationsService } from '../services/notifications.service';
import { Notification } from '../state/notifications.interface';

@Directive({
	// eslint-disable-next-line @angular-eslint/directive-selector
	selector: '[autoDismiss]'
})
export class AutoDismissDirective implements OnInit {
	@Input('autoDismiss') public notification: Notification;

	constructor(private notificationService: NotificationsService) { }

	public ngOnInit(): void {
		if (this.notification.duration) {
			setTimeout(
				() => this.notificationService.dismissNotification(this.notification.id),
				this.notification.duration
			);
		}
	}
}
